import React from "react"
import { useTranslation } from "react-i18next"
import DataTable from "../../../components/DataTable/DataTable"
import { ServiceReview } from "../../../../domain/entities/ServiceReview"
import { ServiceReviewsViewModel } from "../ServiceReviewsViewModel"
import { getServiceReviewsColumns } from "../const/ServiceReviewsTableConfig"

interface ServiceReviewsTableProps {
	viewModel: ServiceReviewsViewModel
	onEditReview: (record: ServiceReview) => void
	onDeleteReview: (reviewId: number) => void
}

export const ServiceReviewsTable: React.FC<ServiceReviewsTableProps> = ({
	viewModel,
	onEditReview,
	onDeleteReview
}) => {
	const { t } = useTranslation("serviceReviews")

	const columns = getServiceReviewsColumns(t, viewModel, onEditReview, onDeleteReview)

	return (
		<DataTable
			columns={columns}
			dataSource={viewModel.serviceReviews}
			loading={viewModel.isLoading}
			tableConfig={viewModel.tableConfig}
		/>
	)
}

export default ServiceReviewsTable
